import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography
} from '@mui/material';

import { IUseDialogControl } from 'modules';



const DialogTitleTypography = styled(Typography)({
  color: '#1E3949',
  fontFamily: 'Noto Serif',
  fontSize: 20,
  fontWeight: 600
});

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    borderRadius: 10,
    padding: 8
  }
});

export interface IProps {
  control: IUseDialogControl
  title: string;
  content: React.ReactNode;
  loading?: boolean;
  onConfirm?: () => Promise<void> | void;
  onCancel?: () => Promise<void> | void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <StyledDialog
      open={props.control.isOpen}
      onClose={props.control.closeDialog}
      style={{ borderRadius: 10 }}
      maxWidth="xs">
      <DialogTitle>
        <DialogTitleTypography>{props.title}</DialogTitleTypography>
      </DialogTitle>

      <DialogContent>{props.content}</DialogContent>

      <DialogActions>
        <Button
          disabled={props.loading}
          variant="outlined"
          color="secondary"
          onClick={props.control.closeDialog}>
            Cancel
        </Button>

        <Button
          style={{ marginLeft: 20 }}
          disabled={props.loading}
          onClick={() => {
            props.control.closeDialog();
            if (props.onConfirm) {
              props.onConfirm();
            }
          }}>
            Confirm
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};
